import React, { AllHTMLAttributes, PropsWithChildren } from 'react';
import cx from 'classnames';
import stylesheet from './Text.less';

export type TextProps = PropsWithChildren<{
  appearance?:
    | 'heading-2'
    | 'heading-3'
    | 'heading-4'
    | 'heading-5'
    | 'heading-6'
    | 'large'
    | 'large-secondary'
    | 'large-bold'
    | 'medium'
    | 'medium-secondary'
    | 'medium-bold'
    | 'small'
    | 'small-secondary'
    | 'small-bold'
    | 'tiny'
    | 'tiny-secondary'
    | 'tiny-bold';
  as?: 'p' | 'span';
  className?: string;
  textWrap?: 'wrap' | 'nowrap' | 'balance' | 'pretty';
}> &
  AllHTMLAttributes<HTMLElement>;

const flagCheck = () => {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  return Boolean((window as any).eee3_fix_google_translate_errors).valueOf();
};

const Text = React.forwardRef<
  HTMLParagraphElement & HTMLSpanElement,
  TextProps
>(function Text(
  {
    appearance = 'medium',
    as: Component = 'p',
    className,
    children,
    textWrap,
    ...props
  },
  forwardedRef,
) {
  return (
    <Component
      className={cx(
        stylesheet.root,
        stylesheet[appearance],
        className,
        textWrap && stylesheet[`text-${textWrap}`],
      )}
      ref={forwardedRef}
      {...props}
    >
      {/* [EEE3-2693]: Fix for crashing email checklist. Wrap with <span>s to get around a Google Translate issue. */}
      {flagCheck() ? (
        <span className={stylesheet.temporarySpan}>{children}</span>
      ) : (
        children
      )}
    </Component>
  );
});

export default Text;
